import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import css from "../../css/listing/price-history.module.css";
import { format, parseISO } from "date-fns";
import moneyFormatter from "../../helper/moneyFormatter";

const HistoryItem = (props) => {
    const { item, listing } = props;

    const [date, setDate] = useState(null);

    useEffect(() => {
        setDate(format(parseISO(item.date), "MM/dd/yyyy"));
    }, [item.date]);

    let diff = null;

    if (item.diff) {
        diff =
            item.diff > 0 ? (
                <span className={css.up}>+{item.diff}%</span>
            ) : (
                <span className={css.down}>{item.diff}%</span>
            );
    }

    let pricePerSqft = null;

    if (listing.living_area) {
        pricePerSqft = item.price / listing.living_area;
    }

    return (
        <tr>
            <td>{date}</td>
            <td>{item.label}</td>
            <td>
                {moneyFormatter(0).format(item.price)} {diff}
            </td>
            <td>{pricePerSqft && moneyFormatter(0).format(pricePerSqft)}</td>
            <td>{item.source}</td>
        </tr>
    );
};

HistoryItem.propTypes = {
    item: PropTypes.object.isRequired,
    listing: PropTypes.object.isRequired,
};

export default HistoryItem;
